module.exports = VueMultiselect;